/**
 * @file 路由配置
 * @date 2021-06-24
 */

export default [
    {
        path: '/',
        redirect: '/trade/spot/',
    },
    // 质押借贷-H5
    {
        path: '/trade/spot/loan-m',
        component: () => import('@/views/spot/h5loan'),
        meta: {
            layout: 'Mobile',
            title: 'loan_pledge',
            ogtitle: 'loan_pledge',
            ogdescription: 'loan_pledge_desc',
        },
    },
    // 质押借贷
    {
        path: '/trade/spot/loan',
        component: () => import('@/views/spot/loan'),
        meta: {
            title: 'loan_pledge',
            ogtitle: 'loan_pledge',
            ogdescription: 'loan_pledge_desc',
        },
    },
    process.env.NODE_ENV !== 'production'
        ? {
            path: '/login/',
            component: () => import('@/views/login'),
        }
        : {},
    {
        path: '/:nofound*',
        component: () => import('@/views/404'),
        meta: {
            layout: 'Mobile',
            title: 'title_404',
        },
    },
];
